export const DEFAULT_LANG = {
  value: "en",
  label: "English",
  href: "/",
  currency: "USD",
} as const;

export const languages = [
  DEFAULT_LANG,
  { value: "en-GB", label: "English (UK)", href: "/gb", currency: "GBP" },
  { value: "en-IE", label: "English (Ireland)", href: "/ie", currency: "EUR" },
  { value: "en-AU", label: "English (AU/NZ)", href: "/au", currency: "AUD" },
  { value: "de", label: "German", href: "/de", currency: "EUR" },
  { value: "es", label: "Spanish", href: "/es", currency: "EUR" },
  { value: "nl", label: "Dutch", href: "/nl", currency: "EUR" },
] as const;

export const locales = languages.map((lang) => lang.value);

export type Language = (typeof languages)[number]["value"];
